import type { GridColumnProps } from '@progress/kendo-react-grid';

export const columns: GridColumnProps[] = [
  {
    title: 'Code',
    field: 'PayCode',
    width: 100,
    className: 'text-left',
    sortable: true,
  },
  {
    title: 'Description',
    field: 'PayDesc',
    width: 200,
    className: 'text-left',
    sortable: true,
  },
  {
    title: 'Method',
    field: 'DeductMethod',
    width: 125,
    className: 'text-left',
    sortable: true,
  },
  {
    title: 'Rate',
    field: 'DeductRate',
    width: 125,
    className: 'text-right',
    format: `{0:n2}`,
    sortable: true,
  },
  {
    title: 'Deductibility',
    field: 'DeductTaxHandling',
    width: 125,
    className: 'text-left',
    sortable: true,
  },
  {
    title: 'Account',
    field: 'AccountNo',
    className: 'text-left',
    sortable: true,
  },
];
